import { MouseEvent } from 'react'
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import { ContextMenuItem, useContextMenu } from 'use-context-menu'
import { useTranslation } from 'libs/i18n'

import { EllipsisMenuProps } from './types'

import { cn } from 'utils/style'

export const ContextMenu = ({ options, className, dataId, item, label }: EllipsisMenuProps) => {
	const { t } = useTranslation()
	const {
		contextMenu: menu,
		onContextMenu: open,
		onKeyDown
	} = useContextMenu(
		<>
			{options
				.filter((option) => !option.hidden?.(item))
				.map((option) => (
					<ContextMenuItem
						key={option.label}
						disabled={option.disabled}
						className="min-w-[9rem] rounded-md"
						onSelect={() => option.action(dataId, item)}>
						{option.label}
					</ContextMenuItem>
				))}
		</>,
		{ alignTo: 'auto-target' }
	)

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		open(event)
	}

	return (
		<>
			<button
				type="button"
				aria-label={label ?? t('Actions')}
				className={cn(
					'grid h-7 w-7 shrink-0 place-items-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
					className
				)}
				onClick={handleClick}
				onKeyDown={onKeyDown}>
				<EllipsisVerticalIcon className="h-4 w-4 stroke-2" />
			</button>
			{menu}
		</>
	)
}
